import { useTranslation } from "react-i18next";

const STATUS_VARIANTS = {
  Validé: { icon: "fas fa-check", badgeClass: "bg-[#E9FBFB] text-[#2AB9B8]" },
  Validated: {
    icon: "fas fa-check",
    badgeClass: "bg-[#E9FBFB] text-[#2AB9B8]",
  },
  Imported: {
    icon: "fas fa-check",
    badgeClass: "bg-[#E9FBFB] text-[#2AB9B8]",
  },
  Importé: {
    icon: "fas fa-check",
    badgeClass: "bg-[#E9FBFB] text-[#2AB9B8]",
  },
  "En traitement": {
    icon: "fas fa-history",
    badgeClass: "bg-[#EFEFFF] text-[#5F5BFF]",
  },
  "In progress": {
    icon: "fas fa-history",
    badgeClass: "bg-[#EFEFFF] text-[#5F5BFF]",
  },
  InProgress: {
    icon: "fas fa-history",
    badgeClass: "bg-[#EFEFFF] text-[#5F5BFF]",
  },
  "En cours": {
    icon: "fas fa-history",
    badgeClass: "bg-[#EFEFFF] text-[#5F5BFF]",
  },
  Erreur: {
    icon: "fas fa-exclamation-triangle",
    badgeClass: "bg-[#FBEBED] text-[#AF2F3C]",
    helperIcon: "fas fa-question-circle",
  },
  Error: {
    icon: "fas fa-exclamation-triangle",
    badgeClass: "bg-[#FBEBED] text-[#AF2F3C]",
    helperIcon: "fas fa-question-circle",
  },
  "A compléter": {
    icon: "fas fa-pen",
    badgeClass: "bg-[#E6ECFD] text-[#0136BD]",
  },
  "À compléter": {
    icon: "fas fa-pen",
    badgeClass: "bg-[#E6ECFD] text-[#0136BD]",
  },
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const variant = STATUS_VARIANTS[status] ?? {
    icon: "fas fa-question-circle",
    badgeClass: "bg-gray-100 text-gray-600",
  };
  const badgeClassMap = {
    "bg-[#E9FBFB] text-[#2AB9B8]": "char-badge-validated",
    "bg-[#EFEFFF] text-[#5F5BFF]": "char-badge-progress",
    "bg-[#FBEBED] text-[#AF2F3C]": "char-badge-error",
    "bg-[#E6ECFD] text-[#0136BD]": "char-badge-tocomplete",
    "bg-gray-100 text-gray-600": "char-badge-outline",
  };
  const badgeClass = badgeClassMap[variant.badgeClass] || variant.badgeClass;
  return (
    <span className={`char-badge ${badgeClass}`}>
      <i className={`${variant.icon} text-xs text-current`} />
      {t(status)}
      {variant.helperIcon && (
        <i className={`${variant.helperIcon} text-xs char-text-secondary`} />
      )}
    </span>
  );
};

export default StatusBadge;
